// extracted by mini-css-extract-plugin
export default {"textInput":"ModalInput_textInput__xUU24","input":"ModalInput_input__+lT37","textArea":"ModalInput_textArea__dprEM"};